import http from 'utils/http';
import {
  getAgencyNotificationMarkReadUrl,
  getAgencyNotificationsMarkAllReadUrl,
  getAgencyNotificationsUnreadCountUrl,
  getAgencyNotificationsUrl
} from './apiUrls';
import { NotificationsListResponse, UnreadCountResponse } from './types';

export function getAgencyNotifications(params?: {
  page?: number;
  per_page?: number;
  unread_only?: boolean;
}): Promise<NotificationsListResponse> {
  return http.get(getAgencyNotificationsUrl(), params);
}

export function getAgencyNotificationsUnreadCount(): Promise<UnreadCountResponse> {
  return http.get(getAgencyNotificationsUnreadCountUrl());
}

export function markAgencyNotificationRead(id: number): Promise<unknown> {
  return http.patch(getAgencyNotificationMarkReadUrl(id));
}

export function markAllAgencyNotificationsRead(): Promise<unknown> {
  return http.post(getAgencyNotificationsMarkAllReadUrl());
}
